export default __webpack_public_path__ + "static/media/invitations1.13a6529f.jpg";